import api from "@/api/axiosApi";
import handleHttpError from "@/util/HttpErrorHandler";

const API_URL = '/evaluation-interval-configs';

export const getAllConfigs = async () => {
    try {
        const response = await api.get(API_URL);
        return response.data;
    } catch (error) {
        console.error('Erreur lors de la récupération des configurations :', error);
        handleHttpError(error, "Impossible de charger les configurations.");
        throw error;
    }
};


export const getConfigs = async (idUsers) => {
    try {
        const response = await api.get(`${API_URL}/user/${idUsers}`);
        return response.data;
    } catch (error) {
        console.error('Erreur lors de la récupération des configurations :', error);
        handleHttpError(error, "Impossible de charger les configurations.");
        throw error;
    }
};


export const addConfig = async (config) => {
    try {
        const response = await api.post(API_URL, config);
        return response.data;
    } catch (error) {
        console.error('Erreur lors de l’ajout de la configuration :', error);
        handleHttpError(error, "Impossible d'enregistrer la configuration.");
        throw error;
    }
};

export const updateConfig = async (id, config) => {
    try {
        const response = await api.put(`${API_URL}/${id}`, config);
        return response.data;
    } catch (error) {
        console.error('Erreur lors de la mise à jour de la configuration :', error);
        handleHttpError(error, "Impossible de mettre à jour la configuration.");
        throw error;
    }
};

export const deleteConfig = async (id) => {
    try {
        await api.delete(`${API_URL}/${id}`);
    } catch (error) {
        console.error('Erreur lors de la suppression de la configuration :', error);
        handleHttpError(error, "Impossible de supprimer la configuration.");
        throw error;
    }
};
